<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-07-28 09:29:22
 * @LastEditors: mrh
 * @LastEditTime: 2022-10-14 14:44:21
--> 
<template>
  <div class="contents">
    <div class="searchs">
      <div class="dw">
        <i class="icon-dingwei iconfont"></i>
        <span>{{ city }}</span>
      </div>
      <van-search
        v-model="searchVals"
        shape="round"
        placeholder="请输入您的地址"
        @input="inputs()"
        @focus="nums = 20"
      />
    </div>
    <baidu-map class="map" :center="center" :zoom="zoom" @ready="handler">
      <bm-view
        :style="{ width: '100%', height: '100%', flex: 1, marginTop: '0px' }"
      ></bm-view>
      <bm-local-search
        v-if="isHide"
        :keyword="searchVal"
        :auto-viewport="true"
        :location="location"
        forceLocal
        :panel='false'
        :nearby="nearby"
        class="searchList"
        @searchcomplete="searchList"
        @markersset="sc"
        @infohtmlset="sc2"
        :pageCapacity="nums"
      ></bm-local-search>
      <bm-local-search
        v-else
        :keyword="searchVal"
        :auto-viewport="true"
        :location="location"
        forceLocal
        :panel='false'
        class="searchList"
        @searchcomplete="searchList"
        @markersset="sc"
        @infohtmlset="sc2"
        :pageCapacity="nums"
      ></bm-local-search>
      <!-- <bm-circle :center="nearby.center" :radius="nearby.radius" v-show='false'></bm-circle> -->
      <div class="searchList" v-show="isShow" ref="searchList">
        <div
          v-for="(item, index) in datas"
          :key="index"
          ref="Lists"
          :class="{ cols: index == indexs }"
          @click="checkAddress(item)"
        >
          <i class="icon-dingwei iconfont dwcolor"></i>
          <div>
            <span class="title">{{ item.title }}</span>
            <span class="address">{{ item.address }}</span>
          </div>
        </div>
      </div>
    </baidu-map>
  </div>
</template>

<script>
export default {
  data() {
    return {
      center: { lng: 0, lat: 0 },
      zoom: 3,
      location: this.$route.query.city,
      searchVals: "",
      searchVal: ["餐馆", "银行", "饮食", "便利店", "地标"],
      datas: [],
      bm: "",
      nearby: {
        center: {
          // lng: 114.4233436231364,
          // lat: 23.11044112232799,
        },
        radius: 400,
      },
      isHide: true,
      nums: 2,
      indexs: 0,
    };
  },
  mounted() {},
  created() {
    // this.isHide = true;
    this.nearby.center.lng = this.$route.query.lng;
    this.nearby.center.lat = this.$route.query.lat;
  },
  methods: {
    inputs() {
      this.isHide = false;
      this.searchVal = this.searchVals;
    },
    handler({ BMap, map }) {
      //   console.log(BMap, map);
      // console.log(this.$route.query)
      // console.log(this.nearby)
      this.center.lng = this.$route.query.lng;
      this.center.lat = this.$route.query.lat;
      this.zoom = 15;
    },
    searchList(a) {
      console.log(a);
      if (a == undefined) {
        return;
      }
      if (Array.isArray(this.searchVal)) {
        this.datas = [
          ...a[0].Xr.slice(0, 2),
          ...a[1].Xr.slice(0, 2),
          ...a[2].Xr.slice(0, 2),
          ...a[3].Xr.slice(0, 2),
          ...a[4].Xr.slice(0, 2),
        ];
      } else {
        this.datas = a.Xr;
      }

      //   console.log(a);
      this.datas.forEach((el) => {
        if (el.hasOwnProperty("phoneNumber")) {
          delete el.phoneNumber;
        }
      });
      // return a.Xr;
    },
    sc(a) {
      a.forEach((el) => {
        delete el.detailUrl;
      });
      return a;
    },
    sc2(a) {
      // console.log(a, "sc2");
      this.datas.forEach((el, index) => {
        if (a.uid == el.uid) {
          // console.log(this.$refs.Lists[0].clientHeight)
          this.indexs = index;
          this.$refs.searchList.scrollTop =
            this.$refs.Lists[0].clientHeight * index;
        }
      });
    },
    checkAddress(obj) {
      this.$router.push({
        path: this.$route.query.type == 0 ? "/openCmt" : "/openShopCmt",
        query: {
          address: obj.address,
          lng: obj.point.lng,
          lat: obj.point.lat,
        },
      });
    },
  },
  computed: {
    city() {
      return this.$route.query.city;
    },
    isShow() {
      return this.searchVal.length > 0 && this.datas.length > 0 ? true : false;
    },
  },
  //   :{
  //     isShow:{}
  //   }
};
</script>
<style lang="scss" scoped>
.searchs {
  height: 28px;
  display: flex;
  align-items: center;
  margin: 4px 13px;
  .dw {
    margin-left: 0;
    margin-right: auto;
    display: flex;
    align-items: center;
    > span {
      font-size: 14px;
      color: #5f646e;
      display: block;
      margin-left: 4px;
    }
    > i {
      color: #5f646e;
    }
  }
  .van-search {
    padding: 1.5px 15px;
    // position: fixed;
    width: 280px;
    height: 26px;
    z-index: 99;
    .van-cell {
      line-height: 20px;
    }
  }
}

.contents {
  width: 100%;
  height: calc(100% - 44px);
  overflow: hidden;
  .map {
    width: 100%;
    height: 100%;
    position: relative;
  }
}
/deep/.searchList {
  width: 340px;
  height: 300px;
  left: 15px;
  position: fixed;
  bottom: 0px;
  background: #fff;
  overflow: auto;
  // > div {
  //   > div:last-child {
  //     > a {
  //       display: none;
  //     }
  //     > div {
  //       float: none !important;
  //       margin-right: 0 !important;
  //       text-align: center;
  //     }
  //   }
  //   li{
  //     // height: px !important;
  //     min-height: 70px !important;
  //     display: flex;
  //     align-items: center;
  //     margin: 0 !important;
  //     padding: 0 !important;
  //     >div{
  //       >div{
  //         span:first-child{
  //           font-size: 20px;
  //           color: #FF1310 !important;
  //           font-weight: bold;
  //         }
  //       }
  //     }
  //   }
  //   b{
  //     display: none;
  //   }
  // }
  > div {
    display: flex;
    align-items: center;
    height: 47px !important;
    width: auto;
    padding: 11.5px 0 !important;
    margin: 0 13px !important;
    border-bottom: 1.04px solid #f5f5f5;
    b{
      display: none;
    }
    a {
      display: none;
    }
    > i {
      color: #8d8d8d;
    }
    > div {
      display: flex;
      flex-flow: column;
      margin-left: 4px;
      .title {
        color: #1d1d1d;
        font-size: 20px;
        font-weight: bold;
      }
      .address {
        color: #8d8d8d;
        font-size: 12px;
      }
    }
  }
  .cols {
    .title {
      color: #ff1310;
    }
    .dwcolor {
      color: #ff1310;
    }
  }
}
</style>